import { LineItem } from '@pperform/pp-data-mappers';
import { FunctionComponent } from 'preact';
import { lineItemTestID } from 'components/MerchantTrackingWidget/constants';
import {
  DescriptionColumn,
  DescriptionWrapper,
  useFormatItemsCard,
} from '../../ItemCommons';
import {
  Name,
  DescriptionBody,
  DescriptionHyperLink,
  DescriptionLabel,
  ReasonForReturnBody,
} from './CardBack.styles';

interface CardBackProps {
  card: LineItem;
  ariaHidden?: boolean;
}

const CardBack: FunctionComponent<CardBackProps> = ({ card, ariaHidden }) => {
  const {
    productName,
    productDescription,
    productUrl,
    productReasonForReturn,
    productCustomReasonForReturn,
  } = useFormatItemsCard(card);

  return (
    <DescriptionWrapper aria-hidden={ariaHidden}>
      <Name
        title={productName}
        isShowFull={false}
        data-testid={`${lineItemTestID}-name`}
      >
        {productName}
      </Name>
      <DescriptionColumn>
        {productReasonForReturn && (
          <div data-testid={`${lineItemTestID}-reason-for-return`}>
            <DescriptionLabel isShowFull={false}>
              {productReasonForReturn.label}:
            </DescriptionLabel>
            <ReasonForReturnBody>
              {productReasonForReturn.value}
            </ReasonForReturnBody>
          </div>
        )}

        {productCustomReasonForReturn && (
          <div data-testid={`${lineItemTestID}-custom-reason-for-return`}>
            <DescriptionLabel isShowFull={false}>
              {productCustomReasonForReturn.label}:
            </DescriptionLabel>
            <ReasonForReturnBody title={productCustomReasonForReturn.value}>
              {productCustomReasonForReturn.value}
            </ReasonForReturnBody>
          </div>
        )}

        {productDescription && (
          <div data-testid={`${lineItemTestID}-description`}>
            <DescriptionLabel isShowFull={false}>
              {productDescription.label}:
            </DescriptionLabel>
            <DescriptionBody
              showReasonForReturn={!!productReasonForReturn?.value}
            >
              {productDescription.value}
            </DescriptionBody>
          </div>
        )}
        {productUrl && (
          <DescriptionHyperLink
            href={productUrl.value}
            target="_blank"
            tabIndex={ariaHidden ? -1 : 0}
            aria-label={`${productUrl.label} ${productName}`}
            data-testid={`${lineItemTestID}-url`}
          >
            {productUrl.label}
          </DescriptionHyperLink>
        )}
      </DescriptionColumn>
    </DescriptionWrapper>
  );
};

export { CardBack };
